import { StyleSheet, TextStyle, ViewStyle } from 'react-native';

import { colors } from '../../colors';

/** Icon cell: 24×24 to match Figma; icon (22×19) centered. */
const iconSize = 24;

const bannerContainerBase: ViewStyle = {
  borderRadius: 4,
  borderWidth: 1,
  flexDirection: 'row',
  minHeight: 58,
  paddingLeft: 5,
  paddingRight: 12,
  paddingVertical: 9
};

const bannerTitleBase: TextStyle = {
  fontSize: 14,
  fontWeight: 'bold',
  lineHeight: 20
};

const bannerMessageBase: TextStyle = {
  fontSize: 12,
  lineHeight: 16,
  marginTop: 2
};

export const styles = StyleSheet.create({
  closeButton: {
    alignItems: 'center',
    height: iconSize,
    justifyContent: 'center',
    position: 'absolute',
    right: 4,
    top: 4,
    width: iconSize
  },
  container: {
    ...bannerContainerBase
  },
  containerDanger: {
    backgroundColor: colors.errorBannerBg,
    borderColor: colors.errorBannerBorder
  },
  containerError: {
    backgroundColor: colors.errorBannerErrorBg,
    borderColor: colors.errorBannerErrorBorder
  },
  containerInfo: {
    backgroundColor: colors.infoBannerBg,
    borderColor: colors.infoBannerBorder
  },
  iconContainer: {
    alignItems: 'center',
    height: iconSize,
    justifyContent: 'center',
    width: iconSize
  },
  infoMessage: {
    ...bannerMessageBase,
    color: colors.infoBannerText
  },
  infoTitle: {
    ...bannerTitleBase,
    color: colors.infoBannerText
  },
  message: {
    ...bannerMessageBase,
    color: colors.errorBannerText
  },
  textColumn: {
    flex: 1,
    marginLeft: 9,
    minWidth: 0
  },
  /**
   * Keeps the text clear of the close button: with the container's paddingRight 12, this puts the
   * text edge 28px from the right — the button's left edge (right 4 + width 24).
   */
  textColumnClosable: {
    marginRight: 16
  },
  title: {
    ...bannerTitleBase,
    color: colors.errorBannerText
  }
});
